import * as React from 'react'
import {Typography, Box} from "@mui/material";

import {LabelCountry} from "@components";


export default function sellerColumn() {
	return {
		name: 'seller', label: 'Seller',
		options: {
			headerAlign: 'left',
			customBodyRowRenderLite: (value, { country, retailer }) => <Box sx={{ display: 'flex', flexDirection: 'column' }}>
				<LabelCountry
					label={retailer}
					country={country}
					sx={{ fontSize: 11 }}
				/>
				<Typography variant="caption" sx={{ color: 'disabled' }}>
					{value}
				</Typography>
			</Box>
		}
	}
}